



























import { CreateElement } from "vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import { IAdminBrand, IBrand } from "@/models/brands";
import { UUID } from "@/data/enums";

@Component({
  components: {
    "brand-logo": () => import("@/components/app/global/brand/logo.vue")
  }
})
export default class SelectBrandList extends Vue {
  // Data

  @Prop({ default: true })
  public readonly showOrgOption!: boolean;

  // Computed

  public get orderedBrands(): IBrand[] {
    return this.$_.orderBy(this.$store.state.auth.admin.brands, [
      "name",
      "asc"
    ]);
  }

  public get brandId(): IBrand["id"] {
    return this.$store.state.brand.id;
  }

  public set brandId(id) {
    if (this.brandId === UUID.ORG) return;
    this.selectBrand({ name: "Org mode", id });
  }

  public get orgRadioBox() {
    return {
      render: (h: CreateElement) => {
        return h("radio-box", {
          props: {
            desc: this.$t("_sentence.org_mode_desc"),
            title: this.$t("_.view_in_organisation_mode"),
            hasRadio: false,
            nativeValue: UUID.ORG,
            value: this.brandId
          },
          on: {
            input: val => (this.brandId = val)
          }
        });
      }
    };
  }

  public selectBrand(brand: IAdminBrand) {
    this.$emit("selected", brand);
    this.$router
      .push({
        name: "adminBrand",
        params: {
          id: brand.id,
          name: brand.name
        }
      })
      .catch(err => err);
  }
}
